import { render, staticRenderFns } from "./contactCard.vue?vue&type=template&id=13a0a9cd&scoped=true&"
import script from "./contactCard.vue?vue&type=script&lang=js&"
export * from "./contactCard.vue?vue&type=script&lang=js&"
import style0 from "./contactCard.vue?vue&type=style&index=0&id=13a0a9cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a0a9cd",
  null
  
)

export default component.exports